(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-set-open-bets-item-count.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-set-open-bets-item-count.js');
"use strict";


svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_setOpenBetsItemCount = () => data => {
  const itemMenuItem = document.querySelector('.js-link-badge-oddset-badge-item');
  if (itemMenuItem) {
    if (data) {
      itemMenuItem.style.display = '';
      itemMenuItem.innerHTML = svs.ui.badge.partials.badge({
        class: 'badge-red badge-small',
        content: data
      });
    } else {
      itemMenuItem.style.display = 'none';
    }
  }
};

 })(window);